import React from "react";
import { Link } from "react-router-dom";
import "../assets/css/Footer.css";
//import Logo from "../assets/statics/ds-logo.png";

import LogoF from "../assets/statics/ds-logo.png";

function Footer() {
  return (
    <>
      <footer>
        <div className="contenido-footer">
          <div className="f-principal">
            <img src={LogoF} alt="" className="logoF" />
            <p>
              Sumate al Design Season 5ta edición. Un programa intensivo de 12{" "}
              <br />
              semanas para convertirte en uno de los perfiles más buscados del
              <br />
              mundo IT. Con Jony y Ceci vas a aprender todo lo necesario para
              <br />
              ser parte del mundo del diseño de interfaces. © Todos los Derechos
              <br />
              Reservados
            </p>
            <img
              src="https://uploads-ssl.webflow.com/63e17cdf18c70e4386603fa9/641a61cecea0047d6b45113e_DATAWEB.jpeg"
              loading="lazy"
              width="39"
              id="w-node-_4229180c-8bea-c386-c704-5c95396c5a0d-396c5a05"
              alt=""
              className="datafiscal"
            ></img>
          </div>
          <div className="coshitas off">
            {/* <div className="f-secciones lista">
              <div className="ftitulo">SECCIONES</div>
              <Link to="/miperfil">Mi cuenta</Link>
              <Link to="/plan">Planes</Link>
              <Link to="https://www.colorclub.online/contacto">Contacto</Link>
            </div>
            <div className="f-escuelas lista">
              <div className="ftitulo">ESCUELAS</div>
              <Link to="/escuela/figma">Figma</Link>
              <Link to="escuela/illustrator">Illustrator</Link>
              <Link to="escuela/photoshop">Photoshop</Link>
              <Link to="escuela/video">Video</Link>
              <Link to="escuela/negocios">Negocios</Link>
              <Link to="escuela/vintage">Vintage</Link>
              <Link to="escuela/presets">Presets</Link>
            </div> */}
            <div className="f-sobre lista">
              <div className="ftitulo">SOBRE</div>
              <Link to="/ohoh">Términos & Condiciones</Link>
              <Link to="/ohoh">Politicas de privacidad</Link>
              <br />
              <div className="footer-social-block">
                <Link to="https://www.instagram.com/colorclub__/">
                  {" "}
                  <img
                    src="https://uploads-ssl.webflow.com/63e17cdf18c70e4386603fa9/646a743bc550b934451786ad_instagram.svg"
                    loading="lazy"
                    width="20"
                    height="20"
                    alt=""
                  />
                </Link>
                <Link to="https://www.youtube.com/@colorclub__">
                  <img
                    src="https://uploads-ssl.webflow.com/63e17cdf18c70e4386603fa9/646a7c98b920caa9e157ad08_youtube.svg"
                    loading="lazy"
                    width="20"
                    height="20"
                    alt=""
                  />
                </Link>
                <Link to="/https://www.tiktok.com/@colorclub__">
                  <img
                    src="https://uploads-ssl.webflow.com/63e17cdf18c70e4386603fa9/646a7cb50462344c0998b953_tiktok.svg"
                    loading="lazy"
                    width="20"
                    height="20"
                    alt=""
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <p className="copy-footer">Copyright © 2023 Design Season</p>
      </footer>
    </>
  );
}

export default Footer;
